module.exports = __webpack_public_path__ + "img/overlay-right.2106a326.svg";